import './carouselList.scss';

export const CarouselListTemplate = (model) => {
	const { alignment, header, header_text_color, header_image, sub_header, headerColor } = model;

	const isContentAvailable = header || sub_header || header_image;

	/* html */
	const html = isContentAvailable
		? `
        <div class="engt-carousel-list-header" 
            style="background-image: url('${header_image}');background-repeat: no-repeat;background-size: cover;text-align: ${alignment}; color: ${headerColor}">
            <span class="title" style="color: ${header_text_color};">
                ${header}
            </span>
            <span class="sub-title" >
                ${sub_header}
            </span>
            <header-button></header-button>
        </div>
        <list-cards></list-cards>
    `
		: /* html */
		  `
            <list-cards></list-cards>
        `;

	return html;
};
